var map = {
	"./largeImages/1984x940.jpg": "23b9",
	"./largeImages/枪王射击.png": "f9c5",
	"./largeImages/沙漠球球1984x940.png": "d790",
	"./largeImages/超级坦克王.jpg": "ae68"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b30c";